import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import type { ContainerWidth } from 'ui/components/4-habitats/Container/Container';
import classNames from 'classnames';
import styles from './ContentSection.module.scss';

export interface ContentSectionProps {
	width: ContainerWidth;
	title: string;
	children?: React.ReactNode;
	background?: 'Light' | 'Dark';
}

export const UI_ContentSection = ({ children, width, title, background = 'Light' }: ContentSectionProps) => {
	const defaultBackground = background == 'Light' || !background;
	return (
		<section
			className={classNames(
				styles.ContentSection,
				{ [styles[`ContentSection___background${background}`]]: background },
				defaultBackground ? 'u-background-default' : 'u-background-contrast',
			)}
		>
			<h2 className={styles.ContentSection_title}>{title}</h2>
			<UI_Container width={width || 'Standard'}>{children}</UI_Container>
		</section>
	);
};
